;(function () {
    document.addEventListener('DOMContentLoaded', function () {
        var planSection = document.querySelector('section.plan')
        if (!planSection) return
        if (!('ontouchstart' in window)) return

        var galleryModal = planSection.querySelector('.plan__images')
        if (galleryModal) {
            document.body.appendChild(galleryModal)
        }

        var state = { scale: 1, x: 0, y: 0 }
        var pinchState = { dist: 0, scale: 1, mid: null }
        var panState = { active: false, startX: 0, startY: 0 }

        var MIN_SCALE = 1
        var MAX_SCALE = 4

        function applyTransform () {
            if (state.scale <= 1) {
                planSection.style.removeProperty('transform')
                planSection.style.removeProperty('transform-origin')
            } else {
                planSection.style.transformOrigin = '0 0'
                planSection.style.transform =
                    'translate(' + state.x + 'px, ' + state.y + 'px) scale(' + state.scale + ')'
            }
        }

        function clampPan () {
            if (state.scale <= 1) {
                state.x = 0
                state.y = 0
                return
            }
            var w = planSection.offsetWidth
            var h = planSection.offsetHeight
            var vw = window.innerWidth
            var vh = window.innerHeight
            state.x = Math.min(0, Math.max(Math.min(0, vw - w * state.scale), state.x))
            state.y = Math.min(0, Math.max(Math.min(0, vh - h * state.scale), state.y))
        }

        function dist (a, b) {
            var dx = b.clientX - a.clientX, dy = b.clientY - a.clientY
            return Math.sqrt(dx * dx + dy * dy)
        }

        function zoomToPoint (screenX, screenY, newScale) {
            var rect = planSection.getBoundingClientRect()
            var dx = screenX - rect.left
            var dy = screenY - rect.top
            var ratio = 1 - newScale / state.scale

            state.x += dx * ratio
            state.y += dy * ratio
            state.scale = newScale
        }

        planSection.addEventListener('touchstart', function (e) {
            if (e.touches.length === 2) {
                e.preventDefault()
                pinchState.dist = dist(e.touches[0], e.touches[1])
                pinchState.scale = state.scale
                pinchState.mid = {
                    x: (e.touches[0].clientX + e.touches[1].clientX) / 2,
                    y: (e.touches[0].clientY + e.touches[1].clientY) / 2
                }
            } else if (e.touches.length === 1 && state.scale > 1.01) {
                panState.active = true
                panState.startX = e.touches[0].clientX - state.x
                panState.startY = e.touches[0].clientY - state.y
            }
        }, { passive: false })

        planSection.addEventListener('touchmove', function (e) {
            if (e.touches.length === 2 && pinchState.dist > 0) {
                e.preventDefault()
                var d = dist(e.touches[0], e.touches[1])
                var newScale = pinchState.scale * (d / pinchState.dist)
                newScale = Math.min(MAX_SCALE, Math.max(MIN_SCALE, newScale))

                zoomToPoint(pinchState.mid.x, pinchState.mid.y, newScale)
                clampPan()
                applyTransform()
            } else if (e.touches.length === 1 && panState.active && state.scale > 1.01) {
                e.preventDefault()
                state.x = e.touches[0].clientX - panState.startX
                state.y = e.touches[0].clientY - panState.startY
                clampPan()
                applyTransform()
            }
        }, { passive: false })

        planSection.addEventListener('touchend', function (e) {
            if (e.touches.length < 2) {
                pinchState.dist = 0
                pinchState.mid = null
            }
            if (e.touches.length === 0) {
                panState.active = false
                if (state.scale < 1.05) {
                    state.scale = 1; state.x = 0; state.y = 0
                    applyTransform()
                }
            }
        })

        var lastTap = 0
        planSection.addEventListener('touchend', function (e) {
            if (e.touches.length !== 0) return
            var now = Date.now()
            if (now - lastTap < 300) {
                e.preventDefault()
                if (state.scale > 1.05) {
                    state.scale = 1; state.x = 0; state.y = 0
                } else {
                    var t = e.changedTouches[0]
                    zoomToPoint(t.clientX, t.clientY, 2.5)
                    clampPan()
                }
                applyTransform()
                lastTap = 0
            } else {
                lastTap = now
            }
        })
    })
})()
